import ArticlePage from "@/components/component/Reuse/ArticlePage/ArticlePage.vue"
export default {
    name: 'TeamsArticlePage',
    components: {ArticlePage},
    computed: {
        isDossier () {
            let isTrue = false
            if (this.$route.name === "teams-dossier-page") isTrue = true
            return isTrue
        }
    },
    methods: {},
}